import httpClient from '@/utilities/service/httpClient'
import AbstractApi from '@/api/abstracts/AbstractApi'
// eslint-disable-next-line prettier/prettier
import type { DashboardType } from '@/api/types/response/DashboardType'

/**
 * @property string apiEnd /api/dashboard
 */
export default class DashboardApi extends AbstractApi {
  fetch(): Promise<DashboardType> {
    return httpClient.get(this.apiEnd)
  }
}
